import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '.';
import { UUID } from 'crypto';
import { handleGlobalSearch } from '@/utils';
import { Coordinator } from '@/utils/types';

export const coordinatorApi = createApi({
    reducerPath: 'coordinatorApi',
    tagTypes: ['coordinators'],
    baseQuery: baseQuery,
    refetchOnReconnect: true,
    endpoints: (builder) => ({
        addCoordinator: builder.mutation({
            query: (coordinator: Partial<Coordinator>) => ({
                url: `coordinators`,
                method: 'POST',
                body: coordinator,
            }),
            invalidatesTags: ['coordinators'],
        }),

        updateCoordinator: builder.mutation({
            query: ({ id, data, clearTreatment }: { id: UUID, data: Partial<Coordinator>, clearTreatment: boolean }) => ({
                url: `coordinators/${id}`,
                method: 'PATCH',
                body: { ...data, clearTreatment },
            }),
            invalidatesTags: ['coordinators'],
        }),

        resetPassword: builder.mutation({
            query: ({ id, password }: { id: string, password: string }) => ({
                url: `coordinators/${id}/reset-password`,
                method: 'PATCH',
                body: { password },
            }),
        }),

        deleteCoordinator: builder.mutation({
            query: (id: UUID) => ({
                url: `coordinators/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['coordinators'],
        }),

        getCoordinators: builder.query({
            query: ({ page, filters }: { page: number; filters: any }) => ({
                url: `coordinators`,
                params: { page, ...handleGlobalSearch(filters, ['email']) },
            }),
            providesTags: ['coordinators'],
        }),

        getCoordinatorById: builder.query<Coordinator, UUID>({
            query: (id: UUID) => ({
                url: `coordinators/${id}`,
            }),
            providesTags: ['coordinators'],
        }),

    }),
});

export const {
    useAddCoordinatorMutation,
    useUpdateCoordinatorMutation,
    useDeleteCoordinatorMutation,
    useGetCoordinatorsQuery,
    useGetCoordinatorByIdQuery, useResetPasswordMutation
} = coordinatorApi;
